<template>
  <div class="look-shop-num ly-flex ly-flex-ali-center" :style="{backgroundColor:bgColor}">
    <div class="look-shop-item ly-flex ly-flex-col ly-flex-ali-center ly-flex-just-center" v-for="item in lookNumData" >
      <p>{{item.name}}</p>
      <div class="look-item-info">
        {{item.num}}
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'lookNumBox',
    props:{
        lookNumData:Array,
        bgColor:String
    }
}
</script>

<style scoped lang="scss">
  .look-shop-num{
    width: 528px;
    height: 161px;
    margin: 20px auto 40px ;
    background: #2c3d77;
    border-radius:10px;
    .look-shop-item{
      width: 50%;
      p{
        font-size:24px;
        color:#fff;
      }
      .look-item-info{
        width:160px;
        height: 48px;
        line-height: 48px;
        margin-top: 20px;
        background: #fff;
        border-radius:10px;
        font-size:28px;
        font-weight:bold;
        color:#2c3d77;
        text-align: center;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/lookNumBox.vue